import { render, staticRenderFns } from "./ProductFootnote.vue?vue&type=template&id=4b18334e&scoped=true"
import script from "./ProductFootnote.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductFootnote.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductFootnote.vue?vue&type=style&index=0&id=4b18334e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18334e",
  null
  
)

export default component.exports